import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import('@/components/TrackingDashboard.vue'),
        },
        {
          path: '/option-transactions',
          name: 'option-transactions',
          component: () => import('../views/OptionTransactionsView.vue'),
        },
        {
          path: '/accounts',
          name: 'accounts',
          component: () => import('../views/Accounts/AccountsView.vue'),
        },
        {
          path: '/stock-transactions',
          name: 'stock-transactions',
          component: () => import('@/views/StockTransactionsView.vue'),
        },
        {
          path: '/transactions',
          name: 'transactions',
          component: () => import('../views/Transactions/TransactionsView.vue'),
        },
       
        {
          path: '/finance-companies',
          name: 'finance-companies',
          component: () => import('@/views/FinanceCompaniesView.vue'),
        },
        {
          path: '/backups',
          name: 'backups',
          component: () => import('@/views/BackupsView.vue'),
        },
        {
          path: '/portfolio-snapshots',
          name: 'portfolio-snapshots',
          component: () => import('@/views/PortfolioSnapshotsView.vue'),
        },
        {
          path: '/stock-positions',
          name: 'stock-positions',
          component: () => import('../components/StockPositionsList.vue'),
        },
        {
          path: '/option-positions',
          name: 'option-positions',
          component: () => import('../components/OptionPositionsList.vue'),
        },
        {
          path: '/option-positions/:id',
          name: 'option-position-detail',
          component: () => import('../components/OptionPositionDetail.vue'),
        },
        {
          path: '/coin-positions',
          name: 'coin-positions',
          component: () => import('@/components/CoinPositionsList.vue'),
        },
        {
          path: '/coin-positions/:id',
          name: 'coin-position-detail',
          component: () => import('@/components/CoinPositionDetail.vue'),
        },
        {
          path: '/fund-positions',
          name: 'fund-positions',
          component: () => import('@/components/FundPositionsList.vue'),
        },
        {
          path: '/fund-positions/:id',
          name: 'fund-position-detail',
          component: () => import('@/components/FundPositionDetail.vue'),
        },
        {
          path: '/stock-positions/:id',
          name: 'stock-position-detail',
          component: () => import('../components/StockPositionDetail.vue'),
        },
        {
          path: '/migration',
          name: 'migration',
          component: () => import('@/views/MigrationWizard.vue'),
        },
        {
          path: '/migration-preview',
          name: 'migration-preview',
          component: () => import('@/views/MigrationPreviewTable.vue'),
        },
        {
          path: '/test-lab',
          name: 'test-lab',
          component: () => import('@/views/TestLab.vue'),
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue'),
    },
  ],
})

// Global navigation guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('auth_token_for_mani');
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isGuestRoute = to.matched.some(record => record.meta.guest);

  if (requiresAuth && !token) {
    // Kullanıcı giriş yapmamış ve korumalı bir sayfa
    next('/login');
  } else if (isGuestRoute && token) {
    // Kullanıcı giriş yapmış ve misafir sayfasına erişmeye çalışıyor
    next();
  } else {
    // Diğer tüm durumlar için izin ver
    next();
  }
});

export default router
